import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get, isNil } from 'lodash'
import { Link } from 'react-router'
import withRouter from '../../lib/withRouter'
import SharedBusinessRulesComponent from '../SharedBusinessRules/SharedBusinessRulesComponent'
import PlanMetadataComponent from './PlanMetadataComponent'

import '../../css/BenefitsSet.scss'

class PlanSharedBusinessRulesShow extends Component {
  static propTypes = {
    show: PropTypes.func.isRequired,
    rulesShow: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    configuration: PropTypes.object,
    benefitsSet: PropTypes.object,
    businessRules: PropTypes.object,
    params: PropTypes.object,
    productLine: PropTypes.string
  }

  componentDidMount() {
    this.props.show(this.props.params.id)
    this.props.rulesShow([], { id: this.props.params.id, date: (new Date()).toISOString().split('T')[0] })
  }

  componentWillUnmount() {
    this.props.reset()
  }

  get needsBenefitsSet() {
    if (isNil(this.props.benefitsSet)) {
      return true
    }

    return get(this.props, 'benefitsSet.id') !== parseInt(this.props.params.id, 10)
  }

  get needsBusinessRules() {
    if (isNil(this.props.businessRules)) {
      return true
    }

    return false
  }

  get newBusinessRuleLink() {
    return (
      <Link
        key="new_business_rule"
        id="new_business_rule"
        title="Add Business Rule"
        className="button quiet-button right"
        to={{
          pathname: '/business_rules/new'
        }}
      > New Business Rule
      </Link>
    )
  }

  handleDateChange = (date) => {
    let dateValue = date
    if (date === '') {
      dateValue = '0001-01-01'
    }

    this.props.rulesShow([], { id: this.props.params.id, date: dateValue })
  }

  render() {
    const { benefitsSet, productLine, businessRules, configuration } = this.props

    if (this.needsBenefitsSet || this.needsBusinessRules) {
      return null
    }
    return (
      <div className="content">
        <div>
          <h1>Plan Business Rule Set</h1>
          <nav>
            {this.newBusinessRuleLink}
          </nav>
          <PlanMetadataComponent
            configuration={configuration}
            benefitsSet={benefitsSet}
            productLine={productLine}
          />
        </div>
        <div>
          <SharedBusinessRulesComponent
            records={businessRules}
            handleDateChange={this.handleDateChange}
          />
        </div>

      </div>
    )
  }
}

export default withRouter(PlanSharedBusinessRulesShow)
